/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ timecode: NonNullable<unknown> }} Audio_Description_Export_Status_Mixing_Audio_ProgressInputs */

const en_audio_description_export_status_mixing_audio_progress = /** @type {(inputs: Audio_Description_Export_Status_Mixing_Audio_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mixing audio... ${i?.timecode}`)
};

const fr_audio_description_export_status_mixing_audio_progress = /** @type {(inputs: Audio_Description_Export_Status_Mixing_Audio_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mixage audio... ${i?.timecode}`)
};

const de_audio_description_export_status_mixing_audio_progress = /** @type {(inputs: Audio_Description_Export_Status_Mixing_Audio_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Audiomischung... ${i?.timecode}`)
};

const it_audio_description_export_status_mixing_audio_progress = /** @type {(inputs: Audio_Description_Export_Status_Mixing_Audio_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mixaggio audio... ${i?.timecode}`)
};

const ru_audio_description_export_status_mixing_audio_progress = /** @type {(inputs: Audio_Description_Export_Status_Mixing_Audio_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Сведение звука... ${i?.timecode}`)
};

const es_audio_description_export_status_mixing_audio_progress = /** @type {(inputs: Audio_Description_Export_Status_Mixing_Audio_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mezclando audio... ${i?.timecode}`)
};

const zh_cn2_audio_description_export_status_mixing_audio_progress = /** @type {(inputs: Audio_Description_Export_Status_Mixing_Audio_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`音频混合中... ${i?.timecode}`)
};

const ja_audio_description_export_status_mixing_audio_progress = /** @type {(inputs: Audio_Description_Export_Status_Mixing_Audio_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`オーディオをミキシングしています... ${i?.timecode}`)
};

const hi_audio_description_export_status_mixing_audio_progress = /** @type {(inputs: Audio_Description_Export_Status_Mixing_Audio_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ऑडियो मिक्सिंग... ${i?.timecode}`)
};

const pt_pt2_audio_description_export_status_mixing_audio_progress = /** @type {(inputs: Audio_Description_Export_Status_Mixing_Audio_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mixagem de áudio... ${i?.timecode}`)
};

/**
* | output |
* | --- |
* | "Mixing audio... {timecode}" |
*
* @param {Audio_Description_Export_Status_Mixing_Audio_ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_mixing_audio_progress = /** @type {((inputs: Audio_Description_Export_Status_Mixing_Audio_ProgressInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Mixing_Audio_ProgressInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_status_mixing_audio_progress(inputs)
	if (locale === "de") return de_audio_description_export_status_mixing_audio_progress(inputs)
	if (locale === "it") return it_audio_description_export_status_mixing_audio_progress(inputs)
	if (locale === "ru") return ru_audio_description_export_status_mixing_audio_progress(inputs)
	if (locale === "es") return es_audio_description_export_status_mixing_audio_progress(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_status_mixing_audio_progress(inputs)
	if (locale === "ja") return ja_audio_description_export_status_mixing_audio_progress(inputs)
	if (locale === "hi") return hi_audio_description_export_status_mixing_audio_progress(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_status_mixing_audio_progress(inputs)
	return en_audio_description_export_status_mixing_audio_progress(inputs)
});